/**
 * Detect Vite / webpack lazy-chunk load failures so we can show a reload CTA
 * instead of a generic crash page.
 */
export function isChunkLoadError(error: Error): boolean {
  const message = error.message.toLowerCase();
  return (
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('loading chunk') ||
    message.includes('loading css chunk') ||
    message.includes('importing a module script failed') ||
    error.name === 'ChunkLoadError'
  );
}
